<div id="termo-uso">
  <div class="field control-input novo-cliente checkbox" tabindex="1">
    <label class="check-exclusivo checkbox-area" for="clube-exclusivo">
      <input type="checkbox" [(ngModel)]="termoDeUsoAceito" (change)="termoDeUsoAlterado()" required id="clube-exclusivo" name="aceite">
      <span class="check-item"></span>
    </label>
    <small *ngIf="type === 'pagamento'">
      Li e concordo com o
        <ng-container *ngTemplateOutlet="href"></ng-container>
      do Clube Montreal.
    </small>

    <small *ngIf="type === 'faca-parte'">
      Li e concordo com a
        <ng-container *ngTemplateOutlet="href"></ng-container>
    </small>

      <small *ngIf="type === 'indique-e-ganhe'" style="line-height: 1.8rem">
          Li o
          <ng-container *ngTemplateOutlet="href"></ng-container>
          e me responsabilizo pela ciencia do meu indicado.
      </small>
    
  </div>
</div>
<ng-template #href>
    <b>
        <a [href]="link | urlPipe" target="_blank">{{insideLinkText()}}</a>
    </b>
</ng-template>
